import { useContext } from 'react';
import UploadQueueContext from './UploadQueueContext';
import { UploadQueueContextValue } from './types';

export const useUploadQueue = (): UploadQueueContextValue => {
  const context = useContext(UploadQueueContext);

  if (!context) {
    throw new Error(
      'useUploadQueue must be used within an UploadQueueProvider'
    );
  }

  return context;
};

export default useUploadQueue;
